import { SvgIcon, useTheme } from "@mui/material";
import type React from "react";
import { useState } from "react";
import { tileTextStyle } from "./style.ts";

const PersonalVehicles: React.FC<{ selected: boolean }> = ({ selected }) => {
	const [hovered, setHovered] = useState(false);
	const theme = useTheme();
	const idleBackground = theme.palette.secondary.main;
	const hoverBackground = theme.palette.secondary.light;
	const selectedBackGround = theme.palette.info.main;

	const backGroundColor = selected ? selectedBackGround : hovered ? hoverBackground : idleBackground;
	return (
		<SvgIcon
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			viewBox="0 0 460 259"
			sx={{ width: "100%", height: "auto" }}
		>
			<rect fill={backGroundColor} width="460" height="259" />
			<line stroke="#fff" x1="460" y1="237.2" x2="0" y2="237.2" />
			<g>
				<path
					stroke="#fff"
					fill="none"
					d="M239.7,176.3s45.9-45.5,131.9-12.2c4.8,2,3.1,8.1-1,10.2-4.5,2.7-16.8,2-47.5,2"
				/>
				<polyline stroke="#fff" fill="none" points="239.7 230.2 239.7 176.3 323.1 176.3 312.8 230.2" />
				<path stroke="#fff" fill="none" d="M148.3,193.4h13.7c-.9,2.1-3.1,5.3-3.6,6.3h-13.8" />
				<path stroke="#fff" fill="none" d="M425.6,195.2c-.9-1.4-5.3-8.4-7.6-12.1h13.1v12.1h-5.5Z" />
				<polyline
					stroke="#fff"
					fill="none"
					points="212.3 230.2 239.7 230.2 241.7 230.2 312.8 230.2 314 230.2 350.9 230.2"
				/>
				<path
					stroke="#fff"
					fill="none"
					d="M400.1,226.2c.9,0,21.4-2.2,29.6-4.7,7.2-2.2,8.1-14.1,8.1-20.5s0-3.4-.1-3.9c0-1.1-1-1.9-2.1-1.9h-4.5v-19.9c0-1-.7-1.8-1.7-2,0,0-26.5-5.2-27-5.3-37.7-19.5-66.5-22.2-92.1-22.2s-48.7,8-49.6,8.4c0,0-.1,0-.2,0,0,0-34.9,17.6-35.7,18-52.4,2.9-72.2,15.1-73.1,15.6-.3.2-.5.4-.6.6l-6.5,11.2v22.7c0,.9.6,1.6,1.4,1.9l16.7,5.7"
				/>
				<circle stroke="#fff" fill="none" cx="375.4" cy="217.3" r="7.7" />
				<circle stroke="#fff" fill="none" cx="187.9" cy="217.3" r="7.7" />
				<path
					stroke="#fff"
					fill="none"
					d="M187.9,198.4c-10.3,0-18.6,7.9-19.2,17.8v2c.5,9.9,8.9,17.8,19.2,17.8s18.6-7.9,19.2-17.8v-2c-.5-9.9-8.9-17.8-19.2-17.8Z"
				/>
				<path
					stroke="#fff"
					fill="none"
					d="M375.4,198.4c-10.3,0-18.6,7.9-19.2,17.8v2c.5,9.9,8.9,17.8,19.2,17.8s18.6-7.9,19.2-17.8v-2c-.5-9.9-8.9-17.8-19.2-17.8Z"
				/>
			</g>
			<text style={tileTextStyle} x="20" y="44">
				Osobní vozidla
			</text>
		</SvgIcon>
	);
};

export default PersonalVehicles;
